import { Injectable } from '@angular/core';
import { PagedAndSortedRequestDto } from '@shared/components/paged-listing-component-base';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ServiceBase } from '../service-base';
import { FileDto, FilesResultDto } from './files-dto';
import { String } from 'typescript-string-operations';
import { ApiRequest } from '@shared/models/api-request';

@Injectable({
  providedIn: 'root',
})
export class FilesService extends ServiceBase {
  public list(request: PagedAndSortedRequestDto, isHideLoading: boolean = true): Observable<FilesResultDto> {
    const apiUrl: string = this._appConstants.API.FILES.LIST;
    const apiRequest: ApiRequest = this._apiService.prepareInputSortAndSearchPage(apiUrl, request, 'athlete__id');

    return this._apiService.get(apiRequest.apiUrl, isHideLoading).pipe(
      map((res: any) => {
        return new FilesResultDto().deserialize({
          totalCount: res.count,
          items: res.results.map((item: FileDto) =>
            new FileDto().deserialize(item)
          ),
        });
      })
    );
  }

  public create(input: any): Observable<Object> {
    const apiUrl: string = this._appConstants.API.FILES.ADD;
    const body = {};
    const apiRequest: ApiRequest = new ApiRequest().deserialize({body, apiUrl,});

    Object.assign(body, input);

    return this._apiService.post(apiRequest.apiUrl, apiRequest.body);
  }

  public update(input: FileDto): Observable<Object> {
    const apiUrl: string = String.Format(this._appConstants.API.FILES.UPDATE, input.id);
    const body = {};
    const apiRequest: ApiRequest = new ApiRequest().deserialize({body, apiUrl,});

    Object.assign(body, input);

    return this._apiService.put(apiRequest.apiUrl, apiRequest.body);
  }

  public delete(id: number): Observable<void | Object> {
    const apiUrl: string = String.Format(this._appConstants.API.FILES.DELETE, id);

    return this._apiService.delete(apiUrl).pipe(
      catchError((response_: any) => {
        return <Observable<void>>(<any>throwError(response_));
      })
    );
  }
  public getById(id: number, isHideLoadingFinal: boolean = true): Observable<any> {
    const apiUrl: string = String.Format(this._appConstants.API.FILES.GET, id);

    return this._apiService.get(apiUrl, isHideLoadingFinal);
  }
}
